/**
 * Include your custom JavaScript here.
 * (Theme hooks: 'variant:changed', 'product:added', 'cart:refresh' - see Warehouse docs.)
 */

/* Big Papa - collapse long collection descriptions with a "Read more" toggle (draft theme 188236497110) */
(function () {
  function init() {
    var fr = (document.documentElement.lang || '').indexOf('fr') === 0;
    var more = fr ? 'Lire la suite' : 'Read more';
    var less = fr ? 'Voir moins' : 'Show less';
    var descs = document.querySelectorAll('.collection__description');
    if (!descs.length) return;
    var st = document.createElement('style');
    st.textContent = '.bp-desc-collapsed{max-height:170px;overflow:hidden;position:relative}' +
      '.bp-desc-collapsed:after{content:"";position:absolute;left:0;right:0;bottom:0;height:70px;background:linear-gradient(rgba(255,255,255,0),#fff)}' +
      '.bp-desc-toggle{margin-top:10px;background:none;border:0;padding:0;color:#1F5FBF;font-weight:600;cursor:pointer;text-decoration:underline}';
    document.head.appendChild(st);
    descs.forEach(function (d) {
      if (d.dataset.bpCollapse || d.scrollHeight < 260) return;
      d.dataset.bpCollapse = '1';
      d.classList.add('bp-desc-collapsed');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bp-desc-toggle';
      b.textContent = more;
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = d.classList.toggle('bp-desc-collapsed') === false;
        b.textContent = open ? less : more;
        b.setAttribute('aria-expanded', String(open));
      });
      d.parentNode.insertBefore(b, d.nextSibling);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
